import { Controller } from 'react-hook-form'
import { FormControl, FormErrorMessage, FormLabel, Radio, RadioGroup, VStack } from '@chakra-ui/react'

import { useEventFormOptions } from '@hooks/useEventFormOptions'

import { MatchEventEditorEventType, MatchEventEditorGoalExtraInfo } from '@common/types'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

export function ExtraInfoRadioGroup() {
    const { zodForm, isFormDisabled, isExtraInfoRequired } = useMatchEditorFormContext()
    const { extraInfo } = useEventFormOptions()

    const eventType = zodForm.watch('type.value')

    if (!extraInfo.length || !isExtraInfoRequired) {
        return null
    }

    const onGoalChanges = (newValue: number, previousValue?: number) => {
        // reset player fields if from/to own goal, as current selection became invalid
        if (
            newValue === MatchEventEditorGoalExtraInfo.own_goal ||
            previousValue === MatchEventEditorGoalExtraInfo.own_goal
        ) {
            zodForm.setValue('player1_id', { value: '', label: '' }, { shouldDirty: true })

            zodForm.setValue('player2_id', { value: '', label: '' }, { shouldDirty: true })
        }
    }

    return (
        <Controller
            control={zodForm.control}
            name="extra_info"
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
                <FormControl
                    isInvalid={!!zodForm.formState.errors.extra_info}
                    isRequired={isExtraInfoRequired}
                    isDisabled={isFormDisabled}>
                    <FormLabel htmlFor={name}>Extra info</FormLabel>
                    <RadioGroup
                        onChange={v => {
                            const newValue = Number(v)

                            if (Number(eventType) === MatchEventEditorEventType.goal) {
                                onGoalChanges(newValue, value)
                            }

                            onChange(newValue)
                        }}
                        value={String(value)}
                        name={name}
                        onBlur={onBlur}
                        ref={ref}>
                        <VStack alignItems="flex-start">
                            {extraInfo.map(({ value: optionValue, label }) => (
                                <Radio key={optionValue} value={optionValue}>
                                    {label}
                                </Radio>
                            ))}
                        </VStack>
                    </RadioGroup>
                    <FormErrorMessage>{zodForm.formState.errors.extra_info?.message}</FormErrorMessage>
                </FormControl>
            )}
        />
    )
}
